import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: '/home/companion-accounts', pathMatch: 'full' },
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/login/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/login/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'messaging',
    loadChildren: () => import('./pages/messaging/messaging.module').then( m => m.MessagingPageModule)
  },
  {
    path: 'filters-modal',
    loadChildren: () => import('./modals/filters-modal/filters-modal.module').then( m => m.FiltersModalPageModule)
  },
  {
    path: 'post-modal',
    loadChildren: () => import('./modals/post-modal/post-modal.module').then( m => m.PostModalPageModule)
  },
  {
    path: 'comments-modal',
    loadChildren: () => import('./modals/comments-modal/comments-modal.module').then( m => m.CommentsModalPageModule)
  },
  {
    path: 'portal-members-modal',
    loadChildren: () => import('./modals/portal-members-modal/portal-members-modal.module').then( m => m.PortalMembersModalPageModule)
  },
  {
    path: 'media-upload-modal',
    loadChildren: () => import('./modals/media-upload-modal/media-upload-modal.module').then( m => m.MediaUploadModalPageModule)
  },
  {
    path: 'link-account-modal',
    loadChildren: () => import('./modals/link-account-modal/link-account-modal.module').then( m => m.LinkAccountModalPageModule)
  },
  {
    path: 'user-media-modal',
    loadChildren: () => import('./modals/user-media-modal/user-media-modal.module').then( m => m.UserMediaModalPageModule)
  },
  {
    path: 'create-event',
    loadChildren: () => import('./modals/create-event-modal/create-event-modal.module').then( m => m.CreateEventModalPageModule)
  },
  {
    path: 'add-player-modal',
    loadChildren: () => import('./modals/add-player-modal/add-player-modal.module').then( m => m.AddPlayerModalPageModule)
  },
  {
    path: 'create-group-modal',
    loadChildren: () => import('./modals/create-group-modal/create-group-modal.module').then( m => m.CreateGroupModalPageModule)
  },
  {
    path: 'event-modal',
    loadChildren: () => import('./modals/event-modal/event-modal.module').then( m => m.EventModalPageModule)
  },
  {
    path: 'report-modal',
    loadChildren: () => import('./modals/report-modal/report-modal.module').then( m => m.ReportModalPageModule)
  },
  {
    path: 'login-modal',
    loadChildren: () => import('./modals/login-modal/login-modal.module').then( m => m.LoginModalPageModule)
  },
  {
    path: 'reply-modal',
    loadChildren: () => import('./modals/reply-modal/reply-modal.module').then( m => m.ReplyModalPageModule)
  },
  {
    path: 'portal-settings',
    loadChildren: () => import('./pages/portal-settings/portal-settings.module').then( m => m.PortalSettingsPageModule)
  },
  {
    path: 'invite-portal-members-modal',
    loadChildren: () => import('./modals/invite-portal-members-modal/invite-portal-members-modal.module').then( m => m.InvitePortalMembersModalPageModule)
  },
  {
    path: 'group-members',
    loadChildren: () => import('./modals/group-members-modal/group-members-modal.module').then( m => m.GroupMembersModalPageModule)
  },
  {
    path: 'password-reset-sent',
    loadChildren: () => import('./pages/login/password-reset-sent/password-reset-sent.module').then( m => m.PasswordResetSentPageModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./pages/login/reset-password/reset-password.module').then( m => m.ResetPasswordPageModule)
  },
  {
    path: 'reset-password-success',
    loadChildren: () => import('./pages/login/reset-password-success/reset-password-success.module').then( m => m.ResetPasswordSuccessPageModule)
  },
  {
    path: 'join-portal',
    loadChildren: () => import('./pages/login/join-portal/join-portal.module').then( m => m.JoinPortalPageModule)
  },
  {
    path: 'verify-user',
    loadChildren: () => import('./pages/login/verify-user/verify-user.module').then( m => m.VerifyUserPageModule)
  },
  {
    path: 'create-survey-modal',
    loadChildren: () => import('./modals/create-survey-modal/create-survey-modal.module').then( m => m.CreateSurveyModalPageModule)
  },
  {
    path: 'register-success',
    loadChildren: () => import('./pages/login/register-success/register-success.module').then( m => m.RegisterSuccessPageModule)
  },
  {
    path: 'edit-post-modal',
    loadChildren: () => import('./modals/edit-post-modal/edit-post-modal.module').then( m => m.EditPostModalPageModule)
  },
  {
    path: 'view-aliases',
    loadChildren: () => import('./pages/view-aliases/view-aliases.module').then( m => m.ViewAliasesPageModule)
  },
  {
    path: 'create-alias-modal',
    loadChildren: () => import('./modals/create-alias-modal/create-alias-modal.module').then( m => m.CreateAliasModalPageModule)
  },
  {
    path: 'alias-members-modal',
    loadChildren: () => import('./modals/alias-members-modal/alias-members-modal.module').then( m => m.AliasMembersModalPageModule)
  },
  {
    path: 'audit-broadcast-modal',
    loadChildren: () => import('./modals/audit-broadcast-modal/audit-broadcast-modal.module').then( m => m.AuditBroadcastModalPageModule)
  },
  {
    path: 'game-modal',
    loadChildren: () => import('./modals/game-modal/game-modal.module').then( m => m.GameModalPageModule)
  },
  {
    path: 'view-portal-roster',
    loadChildren: () => import('./pages/view-portal-roster/view-portal-roster.module').then( m => m.ViewPortalRosterPageModule)
  },
  {
    path: 'edit-roster-player-modal',
    loadChildren: () => import('./modals/edit-roster-player-modal/edit-roster-player-modal.module').then( m => m.EditRosterPlayerModalPageModule)
  },
  {
    path: 'unread-broadcasts',
    loadChildren: () => import('./modals/unread-broadcasts/unread-broadcasts.module').then( m => m.UnreadBroadcastsPageModule)
  },
  {
    path: 'who-likes-this-post-modal',
    loadChildren: () => import('./modals/who-likes-this-post-modal/who-likes-this-post-modal.module').then( m => m.WhoLikesThisPostModalPageModule)
  },
  {
    path: 'verify-new-email',
    loadChildren: () => import('./pages/login/verify-new-email/verify-new-email.module').then( m => m.VerifyNewEmailPageModule)
  },
  {
    path: 'chat-members-modal',
    loadChildren: () => import('./modals/chat-participants-modal/chat-participants-modal.module').then( m => m.ChatParticipantsModalPageModule)
  },
  {
    path: 'create-team-modal',
    loadChildren: () => import('./modals/team-modal/team-modal.module').then( m => m.TeamModalPageModule)
  },
  {
    path: 'review-portal-invites',
    loadChildren: () => import('./modals/review-portal-invites/review-portal-invites-modal.module').then( m => m.ReviewPortalInvitesPageModule)
  },
  {
    path: 'edit-profile-media',
    loadChildren: () => import('./modals/edit-profile-media/edit-profile-media.module').then( m => m.EditProfileMediaPageModule)
  },
  {
    path: 'events-export-modal',
    loadChildren: () => import('./modals/events-export-modal/events-export-modal.module').then( m => m.EventsExportModalPageModule)
  },
  {
    path: 'game-log-modal',
    loadChildren: () => import('./modals/game-log-modal/game-log-modal.module').then( m => m.GameLogModalPageModule)
  },
  {
    path: 'eula-modal',
    loadChildren: () => import('./modals/eula-modal/eula-modal.module').then( m => m.EULAModalPageModule)
  },
  {
    path: 'child-portal-members-modal',
    loadChildren: () => import('./modals/child-portal-members-modal/child-portal-members-modal.module').then( m => m.ChildPortalMembersModalPageModule)
  },
  {
    path: 'portal-documents-modal',
    loadChildren: () => import('./modals/portal-documents-modal/portal-documents-modal.module').then( m => m.PortalDocumentsModalPageModule)
  },
  {
    path: 'add-document-modal',
    loadChildren: () => import('./modals/add-document-modal/add-document-modal.module').then( m => m.AddDocumentModalPageModule)
  },
  {
    path: 'view-media-modal',
    loadChildren: () => import('./modals/view-media-modal/view-media-modal.module').then( m => m.ViewMediaModalPageModule)
  },
  {
    path: 'groups-modal',
    loadChildren: () => import('./modals/groups-modal/groups-modal.module').then( m => m.GroupsModalPageModule)
  },
  {
    path: 'select-rinknet-service-modal',
    loadChildren: () => import('./modals/select-rinknet-service-modal/select-rinknet-service-modal.module').then( m => m.SelectRinknetServiceModalPageModule)
  },
  {
    path: 'gamelog-reply-modal',
    loadChildren: () => import('./modals/gamelog-reply-modal/gamelog-reply-modal.module').then( m => m.GamelogReplyModalPageModule)
  },
  {
    path: 'success',
    loadChildren: () => import('./pages/checkout-success/checkout-success.module').then( m => m.CheckoutSuccessPageModule)
  },
  {
    path: 'cancel',
    loadChildren: () => import('./pages/checkout-cancel/checkout-cancel.module').then( m => m.CheckoutCancelPageModule)
  },
  {
    path: 'recruitment-info-modal',
    loadChildren: () => import('./modals/recruitment-info-modal/recruitment-info-modal.module').then( m => m.RecruitmentInfoModalPageModule)
  },
  {
    path: 'recruit-setup-wizard',
    loadChildren: () => import('./modals/recruit-setup-wizard/recruit-setup-wizard.module').then( m => m.RecruitSetupWizardPageModule)
  },
  {
    path: 'user-setup',
    loadChildren: () => import('./pages/user-setup/user-setup.module').then( m => m.UserSetupPageModule)
  },
  {
    path: 'recruit-setup-wizard',
    loadChildren: () => import('./modals/recruit-setup-wizard/recruit-setup-wizard.module').then( m => m.RecruitSetupWizardPageModule)
  },
  {
    path: 'create-advertisement-modal',
    loadChildren: () => import('./modals/create-advertisement-modal/create-advertisement-modal.module').then( m => m.CreateAdvertisementModalPageModule)
  },  
  {
    path: 'login-rinknet',
    loadChildren: () => import('./pages/login-rinknet/login-rinknet.module').then( m => m.LoginRinknetPageModule)
  },
  {
    path: 'verify-appuser',
    loadChildren: () => import('./pages/login/verify-appuser/verify-appuser.module').then( m => m.VerifyAppuserPageModule)
  },
  {
    path: 'purchase-nz-modal',
    loadChildren: () => import('./modals/purchase-tp-modal/purchase-tp-modal.module').then( m => m.PurchaseTPModalPageModule)
  },
  {
    path: 'report-reader-modal',
    loadChildren: () => import('./modals/report-reader-modal/report-reader-modal.module').then( m => m.ReportReaderModalPageModule)
  },  {
    path: 'video-generator-modal',
    loadChildren: () => import('./modals/video-generator-modal/video-generator-modal.module').then( m => m.VideoGeneratorModalPageModule)
  }

];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true, onSameUrlNavigation: 'reload' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
